import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { getAuthState, getLastOrgId, setLastOrgId } from '@/lib/auth-store';

/**
 * Everything under `/app` requires a session. Landing on `/app` itself resolves
 * to the last-used organisation, the first one available, or onboarding.
 */
export const Route = createFileRoute('/app')({
  beforeLoad: ({ location }) => {
    const { status, organisations } = getAuthState();

    if (status !== 'authenticated') {
      throw redirect({
        to: '/login',
        search: { redirect: `${location.pathname}${location.searchStr}` },
      });
    }

    const atRoot = location.pathname === '/app' || location.pathname === '/app/';
    if (!atRoot) return;

    if (organisations.length === 0) {
      throw redirect({ to: '/onboarding' });
    }

    const remembered = getLastOrgId();
    const target = organisations.find((org) => org.id === remembered) ?? organisations[0];
    if (!target) throw redirect({ to: '/onboarding' });

    setLastOrgId(target.id);
    throw redirect({ to: '/app/$orgId', params: { orgId: target.id } });
  },
  component: Outlet,
});
